import { render, staticRenderFns } from "./live-header.vue?vue&type=template&id=490359c6&scoped=true&"
import script from "./live-header.vue?vue&type=script&lang=js&"
export * from "./live-header.vue?vue&type=script&lang=js&"
import style0 from "./live-header.vue?vue&type=style&index=0&id=490359c6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490359c6",
  null
  
)

export default component.exports